import type * as GoogleAnalytics4Bundle from '@foundation-player/plugin-google-analytics-4';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createGoogleAnalytics4Plugin: PluginFactoryFunction = (builderConfig) => {
  const googleAnalytics4Package = PackageName.PluginGoogleAnalytics4;

  return [
    [googleAnalytics4Package],
    () => {
      const heartbeatGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[googleAnalytics4Package];

      return [
        new (resolveByPackageNameOrThrow<typeof GoogleAnalytics4Bundle>(
          googleAnalytics4Package,
        ).GoogleAnalytics4Plugin)(
          builderConfig.pluginConfigs[heartbeatGlobalName] as GoogleAnalytics4Bundle.PluginConfig,
        ),
      ];
    },
  ];
};
